"use strict";
exports.__esModule = true;
exports.useScrolled = void 0;
var react_1 = require("react");
/**
 * @param {number} threshold - The threshold to check against.
 * @returns True if the user has scrolled greater than the threshold.
 */
var useScrolled = function (threshold) {
    var _a = (0, react_1.useState)(false), isScrolled = _a[0], setIsScrolled = _a[1];
    (0, react_1.useEffect)(function () {
        var handleScroll = function () {
            setIsScrolled(window.scrollY > threshold);
        };
        window.addEventListener("scroll", handleScroll);
        return function () {
            window.removeEventListener("scroll", handleScroll);
        };
    });
    return isScrolled;
};
exports.useScrolled = useScrolled;
